import { captureException } from '@sentry/react';

type OnErrorType = {
  error: unknown;
  userId?: string;
  requestId?: string;
  message: string;
};

const onError = ({ error, userId, requestId, message }: OnErrorType) => {
  captureException(error, {
    extra: {
      userId,
      requestId,
      message,
    },
  });
};

export default onError;
